module.exports = __webpack_public_path__ + "static/media/logo.c65c42a6.jpg";